/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PatientAuthorizationAllowanceBasis = typeof PatientAuthorizationAllowanceBasis[keyof typeof PatientAuthorizationAllowanceBasis];


export const PatientAuthorizationAllowanceBasis = {
  Visits: 'Visits',
  Units: 'Units',
} as const;
